'use strict';

import {AudioConferenceController} from "../audioConference/index";
import ConferenceController from "../audioConference/ConferenceController"

const hark = require('hark');

navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

class WebRTCController extends ConferenceController {
    constructor() {
        super();

        this.localAudioStream = undefined;
        this.myAudioRTCConnection = {};

        this.pcConfig = {
            iceServers: [
                {
                    urls: "stun:stun.l.google.com:19302"
                },
                this.getTURNObj('turn:192.158.29.39:3478?transport=udp', 'JZEOEt2V3Qb0y27GRntt2u2PAYA=', '28224511:1379330808'),
                this.getTURNObj('turn:turn.anyfirewall.com:443?transport=tcp', 'webrtc', 'webrtc')
            ],
            iceTransportPolicy: "all",
            iceCandidatePoolSize: "0"
        };

        this.pcOfferOptions = {
            offerToReceiveAudio: 1,
            offerToReceiveVideo: 0
        };

        this.RTCSignalingState = {
            stable: 'stable',
            haveLocalOffer: 'have-local-offer',
            haveRemoteOffer: 'have-remote-offer',
            closed: 'closed'
        };

        this.RTCIceGatheringState = {
            new: 'new',
            gathering: 'gathering',
            complete: 'complete'
        };

        this.RTCIceConnectionState = {
            new: "new",
            checking: "checking",
            connected: "connected",
            completed: "completed",
            failed: "failed",
            disconnected: "disconnected",
            closed: "closed"
        };

        this.initializeWebRTCConnection();
    }

    // interface declaration

    initializeConference(value) {
        wv.effectController.audioConferenceEnabled = value;
        checkBoxSyncVR('webRTCInit', value);

        updateParticipantConferenceInfo(wv.registeredID.toString(), value);

        this.updateConferenceStatus(value);
        if (!value) {
            AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
        }
    }

    muteAudio(value) {
        wv.effectController.audioEnabled = value;
        checkBoxSyncVR('muteAudio', value);

        for (let userId in this.myAudioRTCConnection) {
            this.muteThisUserAudio(userId, value);
        }
    }

    muteMicrophone(value) {
        wv.effectController.microphoneDisabled = value;
        checkBoxSyncVR('muteMic', value);
        menuViewToolbarController.updateAudioConferenceMuteMicrophoneIcon('muteMic', value ? 'Unmute' : 'Mute', value);

        if (this.localAudioStream) {
            this.localAudioStream.getAudioTracks().forEach(
                audio => audio.enabled = !value
            );
        }

        wv.sendTextMessage(text_updateMuteStatus, wv.registeredID, value ? '1' : '0');
    }

    endConnectionOfThisUser(userId) {
        if (this.isWebRTCObjectAvailable(userId)) {
            console.log("Hanging Up from user: " + getNameFromUserID(userId));

            try {
                if (this.myAudioRTCConnection[userId].stream) {
                    this.myAudioRTCConnection[userId].stream.getAudioTracks().forEach(
                        stream => stream.stop()
                    );
                }
            } catch (error) {
                console.log(error);
            }

            this.myAudioRTCConnection[userId].RTCPeer.close();
            delete this.myAudioRTCConnection[userId];
        } else {
            console.log("User not found for Hanging Up: " + getNameFromUserID(userId));
        }

        this.removeUserFromCanvas(userId);
    }

    // server message handler

    setClientCandidate(userId, message) {
        let self = this;
        if (!self.isWebRTCObjectAvailable(userId))
            return;

        if (message.label === 'endOfCandidate') {
            return;
        }

        const candidate = new RTCIceCandidate({
            sdpMLineIndex: message.label,
            candidate: message.candidate
        });

        self.myAudioRTCConnection[userId].RTCPeer.addIceCandidate(candidate);
        const obj = self.parseCandidate(message.candidate);

        if (!obj.protocol || !obj.address) {
            self.removeUserFromCanvas(userId);
        }

        console.log("remote ICECandidate: " + obj.protocol + " : " + obj.address + " from user: " + getNameFromUserID(userId));
    }

    handleClientFailure(userId) {
        console.error("Failed to create connection to user: " + getNameFromUserID(userId));
        this.endConnectionOfThisUser(userId);
    }

    stopConference() {
        for (let userId in this.myAudioRTCConnection) {
            this.endConnectionOfThisUser(userId);
        }

        this.updateConferenceStatus(false);

        this.updateConferenceMenuStatus(false);
        AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
    }

    handleEndCall(userId) {
        if (parseInt(userId) === wv.registeredID) {
            this.endAllConnection();
        } else if (wv.effectController.Participants[parseInt(userId)].is_presenter) {
            this.endConnectionOfThisUser(userId);
        }

        updateParticipantConferenceInfo(userId, false);
        if (wv.effectController.audioConferenceEnabled) {
            AudioConferenceController.playNotification(AudioConferenceController.NotificationTypeEnum.LEFT);
        }
    }

    handleWebRTCOffer(offer, userId) {
        this.createPeerConnection(userId);
        this.setRemoteDescription(offer, userId);
        this.doAnswer(userId);
    }

    setRemoteDescription(message, userId) {
        if (!this.isWebRTCObjectAvailable(userId))
            return;
        console.log("Remote description: ", message, " set for user: " + getNameFromUserID(userId));
        this.myAudioRTCConnection[userId].RTCPeer.setRemoteDescription(new RTCSessionDescription(message));
    }

    callThisUser(userId) {
        this.createPeerConnection(userId);
        this.doCall(userId);
    }

    /*************** *******************************************************/

    addUserInCanvas(userId) {
        this.addUserEvent.detail.userId = userId;
        document.dispatchEvent(this.addUserEvent);
    }

    removeUserFromCanvas(userId) {
        this.removeUserEvent.detail.userId = userId;
        document.dispatchEvent(this.removeUserEvent);
    }

    updateConferenceStatus(value) {
        this.updateConferenceStatusEvent.detail.conferenceStatus = value;
        document.dispatchEvent(this.updateConferenceStatusEvent);
    }

    getTURNObj(turnStr, username, credential) {
        return {
            urls: turnStr,
            username: username,
            credential: credential
        };
    }

    initializeWebRTCConnection() {
        if (navigator.getUserMedia) {
            navigator.getUserMedia({audio: true}, this.successCallbackStream.bind(this), this.failCallbackStream);
        } else {
            this.failCallbackStream('Insecure context!');
        }
    }

    successCallbackStream(myStream) {
        this.localAudioStream = modifyGain(myStream, 2.5);
        console.log("Local user media stream found");
        for (let userId in this.myAudioRTCConnection) {
            this.addAudioStreamToThisUser(userId);
        }

        function modifyGain(stream, gainValue) {
            try {
                let ctx = new AudioContext();
                let src = ctx.createMediaStreamSource(stream);
                let dst = ctx.createMediaStreamDestination();
                let gainNode = ctx.createGain();
                gainNode.gain.setValueAtTime(gainValue, ctx.currentTime);
                [src, gainNode, dst].reduce((a, b) => a && a.connect(b));
                return dst.stream;
            } catch (e) {
                console.error("Gain Error on media stream: ", e);
                return stream;
            }
        }
    }

    addAudioStreamToThisUser(userId) {
        if (this.localAudioStream && this.myAudioRTCConnection[userId]) {
            console.log("Added local Audio stream to user: " + getNameFromUserID(userId));
            this.localAudioStream.getTracks().forEach(
                track => {
                    this.myAudioRTCConnection[userId].RTCPeer.addTrack(track, this.localAudioStream);
                });
        }
    }

    failCallbackStream(error) {
        console.error('navigator.getUserMedia error: ', error);
    }

    createPeerConnection(userId) {
        let self = this;

        try {
            console.log("Started connecting to user " + getNameFromUserID(userId));

            self.myAudioRTCConnection[userId] = {};
            self.myAudioRTCConnection[userId].RTCPeer = new RTCPeerConnection(self.pcConfig);
            self.myAudioRTCConnection[userId].RTCPeer.onicecandidate = function (event) {
                self.sendIceCandidate(event, userId);
            };
            self.myAudioRTCConnection[userId].RTCPeer.oniceconnectionstatechange = function (event) {
                self.oniceconnectionstatechange(event, userId);
            };
            // self.myAudioRTCConnection[userId].RTCPeer.onicegatheringstatechange = function (event) {
            //
            // };
            //
            // self.myAudioRTCConnection[userId].RTCPeer.onnegotiationneeded = function (event) {
            //
            // };

            self.myAudioRTCConnection[userId].RTCPeer.onaddstream = function (event) {
                console.log('enter to the remote stream');
                self.handleRemoteStreamAdded(event, userId);
            };
            self.myAudioRTCConnection[userId].RTCPeer.onremovestream = function (event) {
                self.handleRemoteStreamRemoved(event, userId);
            };
            self.addAudioStreamToThisUser(userId);
        } catch (ex) {
            delete self.myAudioRTCConnection[userId];
            console.error("Failed to create PeerConnection, exception: " + ex.message);
            alert("Cannot create RTCPeerConnection object.");
        }
    }

    isWebRTCObjectAvailable(userId) {
        return this.myAudioRTCConnection && this.myAudioRTCConnection[userId];
    }

    handleRemoteStreamAdded(event, userId) {
        if (!this.isWebRTCObjectAvailable(userId) || this.myAudioRTCConnection[userId].stream) {
            console.log('remote stream not found');
            return;
        }

        console.log("Remote stream added from user: " + getNameFromUserID(userId));
        let audioOutput = document.createElement('audio');
        audioOutput.srcObject = event.stream;
        audioOutput.autoplay = true;
        audioOutput.play();
        audioOutput.volume = 1.0;
        this.myAudioRTCConnection[userId].stream = event.stream;
        this.muteThisUserAudio(userId, wv.effectController.audioEnabled);

        this.listeningStream(userId, event.stream);
    }

    listeningStream(userId, stream) {
        let self = this;

        const speech = hark(stream, self.harkOptions);

        speech.on('speaking', function () {
            self.addUserInCanvas(userId);
        });

        speech.on('stopped_speaking', function () {
            self.removeUserFromCanvas(userId);
        });
    }

    handleRemoteStreamRemoved(event, userId) {
        console.log("Remote stream removed. Event: ", event, "user: " + getNameFromUserID(userId));
    }

    doCall(userId) {
        const self = this;
        if (!self.isWebRTCObjectAvailable(userId))
            return;
        console.log("Sending offer to peer: " + getNameFromUserID(userId));
        self.myAudioRTCConnection[userId].RTCPeer.createOffer(function (event) {
                self.setLocalAndSendOffer(event, userId);
            }
            ,
            function (event) {
                self.handleCreateOfferError(event, userId);
            }
            ,
            self.pcOfferOptions
        );
    }

    doAnswer(userId) {
        const self = this;
        if (!self.isWebRTCObjectAvailable(userId))
            return;
        console.log("Sending answer to peer: " + getNameFromUserID(userId));
        self.myAudioRTCConnection[userId].RTCPeer.createAnswer(function (event) {
            self.setLocalAndSendAnswer(event, userId);
        }, function (event) {
            self.onCreateSessionDescriptionError(event, userId);
        });
    }

    setLocalAndSendOffer(sessionDescription, userId) {
        // TODO
        // Set Opus as the preferred codec in SDP if Opus is present.
        //  sessionDescription.sdp = preferOpus(sessionDescription.sdp);
        this.myAudioRTCConnection[userId].RTCPeer.setLocalDescription(sessionDescription);
        console.log("Sending Offer: ", sessionDescription, "to user: " + getNameFromUserID(userId));
        this.sendWebRTCOffer(sessionDescription, userId);
    }

    setLocalAndSendAnswer(sessionDescription, userId) {
        // TODO
        // Set Opus as the preferred codec in SDP if Opus is present.
        //  sessionDescription.sdp = preferOpus(sessionDescription.sdp);
        this.myAudioRTCConnection[userId].RTCPeer.setLocalDescription(sessionDescription);
        console.log("Sending answer: ", sessionDescription, "to User: " + getNameFromUserID(userId));
        this.sendWebRTCAnswer(sessionDescription, userId);
    }

    handleCreateOfferError(event, userId) {
        console.error("CreateOffer() error: ", event, " For user " + getNameFromUserID(userId));
    }

    onCreateSessionDescriptionError(error, userId) {
        console.error("Failed to create session description: ", error.toString(), " For User " + getNameFromUserID(userId));
    }

    endAllConnection() {
        for (let userId in this.myAudioRTCConnection) {
            this.endConnectionOfThisUser(userId);
        }

        this.updateConferenceMenuStatus(false);
    }

    muteThisUserAudio(userId, value) {
        if (this.myAudioRTCConnection[userId].stream) {
            this.myAudioRTCConnection[userId].stream.getAudioTracks().forEach(
                stream => stream.enabled = value
            );
        }
    }

    sendWebRTCOffer(offer, userId) {
        this.service.webRTCOffer({offer, userId});
    }

    sendIceCandidate(event, userId) {
        if (event.candidate) {
            const obj = this.parseCandidate(event.candidate.candidate);

            if (!obj.type || !obj.protocol || !obj.address) {
                AudioConferenceController.removeUserFromCanvas(userId);
            }

            console.log("local ICECandidate: " + obj.type + ":" + obj.protocol + " : " + obj.address + " For user: " + getNameFromUserID(userId));

            this.service.sendIceCandidate({
                userId: userId,
                label: event.candidate.sdpMLineIndex,
                id: event.candidate.sdpMid,
                candidate: event.candidate.candidate
            });

        } else {
            console.log("End of candidates for user: " + getNameFromUserID(userId));

            this.service.sendIceCandidate({
                userId: userId,
                label: "endOfCandidate",
                id: "endOfCandidate",
                candidate: "endOfCandidate"
            });
        }
    }

    oniceconnectionstatechange(event, userId) {
        if (!this.isWebRTCObjectAvailable(userId)) {
            return;
        }

        const pc = this.myAudioRTCConnection[userId].RTCPeer;
        console.log("Ice Connection state: " + pc.iceConnectionState + "For User: " + getNameFromUserID(userId));

        if (pc.iceConnectionState === this.RTCIceConnectionState.connected) {
            console.log("Connected to user: " + getNameFromUserID(userId));
            const text = "Connected to user: " + getNameFromUserID(userId);
            VRMessageController.addMessage({text: text, priority: VrMessagePriorityEnum.LOWPRIORITYINFO});
            updateParticipantConferenceInfo(userId.toString(), true);
        }

        if (pc.iceConnectionState === this.RTCIceConnectionState.failed) {
            this.service.iceFailed(userId);
        }
    }

    sendWebRTCAnswer(answer, userId) {
        this.service.sendAnswer({userId, answer});
    }

    service = {
        webRTCOffer(payload) {
            wv.sendTextMessage(text_webRTCOffer + text_seperator + payload.userId + ":" + JSON.stringify(payload.offer));
        },

        sendIceCandidate(payload) {
            wv.sendTextMessage(text_webRTC_ICECandidate + text_seperator + payload.userId + ":" + JSON.stringify({
                label: payload.label,
                id: payload.id,
                candidate: payload.candidate
            }));
        },

        sendAnswer(payload) {
            wv.sendTextMessage(text_webRTCAnswer + text_seperator + payload.userId + ":" + JSON.stringify(payload.answer));
        },

        iceFailed(userId) {
            wv.sendTextMessage(text_iceFailed + text_seperator + userId);
        }
    };

    onPermissionForConference(value) {
        this.updateConferenceMenuStatus(value);

        if (value) {
            this.muteMicrophone(value);
        }

        this.updateConferenceStatus(value);
    }

    parseCandidate(text) {
        const candidateStr = 'candidate:';
        const pos = text.indexOf(candidateStr) + candidateStr.length;
        const [foundation, component, protocol, priority, address, port, type] =
            text.substr(pos).split(' ');
        return {
            'component': component,
            'type': type,
            'foundation': foundation,
            'protocol': protocol,
            'address': address,
            'port': port,
            'priority': priority
        };
    }


    /************* **********************************/
// if (location.hostname !== "localhost") {
//     requestTurn(
//         "https://computeengineondemand.appspot.com/turn?username=41784574&key=4080218913"
//     );
// }

    requestTurn(turnURL) {
        let turnExists = false;
        for (let i in this.pcConfig.iceServers) {
            if (this.pcConfig.iceServers[i].urls.substr(0, 5) === "turn:") {
                turnExists = true;
                break;
            }
        }

        if (!turnExists) {
            console.log("Getting TURN server from ", turnURL);
            // No TURN server. Get one from computeengineondemand.appspot.com:
            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const turnServer = JSON.parse(xhr.responseText);
                    console.log("Got TURN server: ", turnServer);
                    this.pcConfig.iceServers.push({
                        urls: "turn:" + turnServer.username + "@" + turnServer.turn,
                        credential: turnServer.password
                    });
                }
            };
            xhr.open("GET", turnURL, true);
            xhr.send();
        }
    }

// Set Opus as the default audio codec if it's present.
    preferOpus(sdp) {
        let sdpLines = sdp.split("\r\n");
        let mLineIndex;
        // Search for m line.
        for (let i = 0; i < sdpLines.length; i++) {
            if (sdpLines[i].search("m=audio") !== -1) {
                mLineIndex = i;
                break;
            }
        }

        if (mLineIndex === null) {
            return sdp;
        }

        // If Opus is available, set it as the default in m line.
        for (let i = 0; i < sdpLines.length; i++) {
            if (sdpLines[i].search("opus/48000") !== -1) {
                const opusPayload = this.extractSdp(sdpLines[i], /:(\d+) opus\/48000/i);

                if (opusPayload) {
                    sdpLines[mLineIndex] = this.setDefaultCodec(
                        sdpLines[mLineIndex],
                        opusPayload
                    );
                }

                break;
            }
        }

        // Remove CN in m line and sdp.
        sdpLines = this.removeCN(sdpLines, mLineIndex);

        sdp = sdpLines.join("\r\n");
        return sdp;
    }

    extractSdp(sdpLine, pattern) {
        const result = sdpLine.match(pattern);
        return result && result.length === 2 ? result[1] : null;
    }

// Set the selected codec to the first in m line.
    setDefaultCodec(mLine, payload) {
        const elements = mLine.split(" ");
        let newLine = [];
        let index = 0;
        for (let i = 0; i < elements.length; i++) {
            if (index === 3) {
                // Format of media starts from the fourth.
                newLine[index++] = payload; // Put target payload to the first.
            }
            if (elements[i] !== payload) {
                newLine[index++] = elements[i];
            }
        }
        return newLine.join(" ");
    }

// Strip CN from sdp before CN constraints is ready.
    removeCN(sdpLines, mLineIndex) {
        const mLineElements = sdpLines[mLineIndex].split(" ");
        // Scan from end for the convenience of removing an item.
        for (let i = sdpLines.length - 1; i >= 0; i--) {
            const payload = this.extractSdp(sdpLines[i], /a=rtpmap:(\d+) CN\/\d+/i);

            if (payload) {
                const cnPos = mLineElements.indexOf(payload);

                if (cnPos !== -1) {
                    // Remove CN payload from m line.
                    mLineElements.splice(cnPos, 1);
                }
                // Remove CN line in sdp
                sdpLines.splice(i, 1);
            }
        }

        sdpLines[mLineIndex] = mLineElements.join(" ");
        return sdpLines;
    }

    updateConferenceMenuStatus(value) {
        wv.effectController.audioConferenceEnabled = value;
        checkBoxSyncVR('webRTCInit', value);
        updateParticipantConferenceInfo(wv.registeredID.toString(), value);
    }
}

export default WebRTCController;
